// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../styles/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.obligations-page-template-right {
  width: calc(100% - 22.9375rem);
  height: 100%;
  margin-left: 22.9375rem;
  background-color: var(--background-color-darker);
  padding: 1.5rem 2.62rem;
  min-height: 100vh;
}

.obligations-hr {
  background: var(--grey);
  width: 100%;
  height: 0.0625rem;
  margin: 2.12rem 0rem;
}

.obligations {
  height: 100%;
}

.obligations-content {
  border-radius: 1.875rem;
  background: #fff;
  padding: 1.5rem;
}

.obligations-ques-ans {
  margin-top: 2.19rem;
}

/* Tab styles */
.tabs-overview {
  width: 100%;
}

.tab-button {
  padding: 0.75rem 1.25rem;
  background: transparent;
  border: none;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  color: var(--text-dark);
  position: relative;
  transition: all 0.3s ease;
}

.tab-button.active {
  color: var(--primary-color);
  font-weight: 600;
}

.tab-button.active:after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--primary-color);
}

.tabs-hr {
  height: 1px;
  width: 100%;
  background-color: #e0e0e0;
  margin-bottom: 1.5rem;
}

.tab-content {
  display: none;
  width: 100%;
}

.tab-content.active {
  display: block;
}

/* Table styles */
.obligations-table-container {
  margin-top: 1rem;
  width: 100%;
  overflow-x: auto;
}

.obligations-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.table-header-row {
  background-color: #2970ff;
  color: white;
}

.obligations-table th {
  background-color: #2970ff; /* Stronger primary color */
  color: white;
  text-align: left;
  padding: 1rem;
  font-weight: 600;
  border: 1px solid #2260df; /* Darker border for contrast */
  position: sticky;
  top: 0;
  z-index: 1;
}

.obligations-table thead {
  display: table-header-group; /* Ensure header is visible */
}

.obligations-table th:first-child {
  border-top-left-radius: 0.25rem;
}

.obligations-table th:last-child {
  border-top-right-radius: 0.25rem;
}

.obligations-table td {
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  vertical-align: top;
}

.obligations-table tr:last-child td {
  border-bottom: none;
}

.obligations-table tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.02);
}

.obligations-table tr:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

/* Add responsive styles for mobile */
@media (max-width: 768px) {
  .obligations-page-template-right {
    width: 100%;
    margin-left: 0;
    padding: 1rem;
  }
  
  .obligations-table th, 
  .obligations-table td {
    padding: 0.75rem 0.5rem;
    font-size: 0.9rem;
  }
  
  .tab-button {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/obligations/obligations.css"],"names":[],"mappings":"AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,gDAAgD;EAChD,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yBAAyB,EAAE,+BAA+B;EAC1D,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,2BAA2B,EAAE,6BAA6B;AAC5D;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,qCAAqC;AACrC;EACE;IACE,WAAW;IACX,cAAc;IACd,aAAa;EACf;;EAEA;;IAEE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;AACF","sourcesContent":["@import \"../../styles/global.css\";\n\n.obligations-page-template-right {\n  width: calc(100% - 22.9375rem);\n  height: 100%;\n  margin-left: 22.9375rem;\n  background-color: var(--background-color-darker);\n  padding: 1.5rem 2.62rem;\n  min-height: 100vh;\n}\n\n.obligations-hr {\n  background: var(--grey);\n  width: 100%;\n  height: 0.0625rem;\n  margin: 2.12rem 0rem;\n}\n\n.obligations {\n  height: 100%;\n}\n\n.obligations-content {\n  border-radius: 1.875rem;\n  background: #fff;\n  padding: 1.5rem;\n}\n\n.obligations-ques-ans {\n  margin-top: 2.19rem;\n}\n\n/* Tab styles */\n.tabs-overview {\n  width: 100%;\n}\n\n.tab-button {\n  padding: 0.75rem 1.25rem;\n  background: transparent;\n  border: none;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  color: var(--text-dark);\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.tab-button.active {\n  color: var(--primary-color);\n  font-weight: 600;\n}\n\n.tab-button.active:after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: var(--primary-color);\n}\n\n.tabs-hr {\n  height: 1px;\n  width: 100%;\n  background-color: #e0e0e0;\n  margin-bottom: 1.5rem;\n}\n\n.tab-content {\n  display: none;\n  width: 100%;\n}\n\n.tab-content.active {\n  display: block;\n}\n\n/* Table styles */\n.obligations-table-container {\n  margin-top: 1rem;\n  width: 100%;\n  overflow-x: auto;\n}\n\n.obligations-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e0e0e0;\n}\n\n.table-header-row {\n  background-color: #2970ff;\n  color: white;\n}\n\n.obligations-table th {\n  background-color: #2970ff; /* Stronger primary color */\n  color: white;\n  text-align: left;\n  padding: 1rem;\n  font-weight: 600;\n  border: 1px solid #2260df; /* Darker border for contrast */\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.obligations-table thead {\n  display: table-header-group; /* Ensure header is visible */\n}\n\n.obligations-table th:first-child {\n  border-top-left-radius: 0.25rem;\n}\n\n.obligations-table th:last-child {\n  border-top-right-radius: 0.25rem;\n}\n\n.obligations-table td {\n  padding: 1rem;\n  border-bottom: 1px solid #e0e0e0;\n  border-right: 1px solid #e0e0e0;\n  vertical-align: top;\n}\n\n.obligations-table tr:last-child td {\n  border-bottom: none;\n}\n\n.obligations-table tr:nth-child(even) {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n.obligations-table tr:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n/* Add responsive styles for mobile */\n@media (max-width: 768px) {\n  .obligations-page-template-right {\n    width: 100%;\n    margin-left: 0;\n    padding: 1rem;\n  }\n  \n  .obligations-table th, \n  .obligations-table td {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.9rem;\n  }\n  \n  .tab-button {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
